import { Injectable } from '@angular/core';
import { StktuServicePkg } from './stktuPkg.service';
import { Stktu } from '../entity/Stktu-angular';
import { idNameItem, jkLib, jkRestReturn } from 'jk-service';
import { Stklm, Stkma } from '../_entity_stk';

/**
 * 期貨委託
 */
@Injectable({
  providedIn: 'root',
})
export class StktuService extends StktuServicePkg {
  newItem: Stktu = this.getDefaultItem();
  buysaleTitle: string = '';

  get buysale(): string {
    return this.newItem.TU007.toString();
  }
  set buysale(value: string) {
    this.newItem.TU007 = parseInt(value);
    if (this.newItem.TU007 === 0) {
      this.buysaleTitle = '確認買進';
    } else {
      this.buysaleTitle = '確認賣出';
    }
  }
  // TU008 當沖  SHORT	sDayTrade;			//當沖 0:否 1:是
  get dayTrade(): string {
    return this.newItem.TU008.toString();
  }
  set dayTrade(value: string) {
    this.newItem.TU008 = parseInt(value);
  }
  // TU009	倉別 N 4    sNewClose;			新平倉  0:新倉 1:平倉 2:自動  {新期貨、選擇權使用}
  get newClose(): string {
    return this.newItem.TU009.toString();
  }
  set newClose(value: string) {
    this.newItem.TU009 = parseInt(value);
  }
  // TU006 委託條件 N     4   [DEF:0] SHORT	sTradeType;	0:ROD  1:IOC  2:FOK
  get tradeType(): string {
    return this.newItem.TU006.toString();
  }
  set tradeType(value: string) {
    this.newItem.TU006 = parseInt(value);
  }
  // SHORT	sReserved;		//{期貨委託SendFutureOrderCLR適用}盤別， 0:盤中(T盤及T+1盤) 1:T盤預約
  tu012List: idNameItem[] = [
    { id: '0', name: '盤中' },
    { id: '1', name: '預約' },
  ];
  get tu012(): string {
    return this.newItem.TU012.toString();
  }
  set tu012(value: string) {
    this.newItem.TU012 = parseInt(value);
  }

  tu014YN: string = 'N'; // 虛構
  get qty(): number {
    return this.newItem.TU011;
  }
  set qty(value: number) {
    this.newItem.TU011 = value;
  }
  constructor() {
    super();
    this.defaultManagerField(this.newItem, true);
    this.newItem.TU001 = jkLib.nowDate();
    this.newItem.TU011 = 1;
    this.newItem.KEY0 = '1';
  }
  /*get stockno(): string {
    return this.newItem.TU005;
  }
  set stockno(value: string) {
    this.newItem.TU005 = value;
  }*/
  async doBeforeSend(uId: string): Promise<boolean> {
    this.newItem.TU018 = uId;
    this.newItem.TU001 = jkLib.nowDate();
    this.newItem.TU027 = jkLib.nowTime8();
    let ret = await this.orm.autoNo(
      'data',
      this.tableName,
      this.keyFields.join(','),
      this.newItem.TU001 + ',' + this.newItem.TU002,
      this.newItem.TU001
    );
    if (ret.result) {
      this.newItem.TU003 = ret.data;
      let bool = this.checkRequiredFields(this.newItem, ret);
      if (!bool) return false;
    } else {
      alert('取序號錯誤:' + ret.message);
      return false;
    }
    return true;
  }
}
